import externalLinks from "../../../constants/externalLinks";
import { getBasename } from "../../../helpers/routingHelpers";
import FooterItem from "../FooterItem";
import FooterDoNotSellItemSvg from "../FooterMoreStuffSection/FooterDoNotSellItemSvg";

import footerMoreStuffSectionStyles from "../FooterMoreStuffSection/FooterMoreStuffSection.module.scss";
import displayCookieConsentModal from "../../../features/evidon/helpers/displayCookieConsentModal";

import minimalFooterStyles from "./minimalFooter.module.scss";
import FooterCopyrightSection from "../FooterCopyrightSection/FooterCopyrightSection";

import { ContentWrapper } from "@crunchyroll/cx-web-components";

const MinimalFooter = () => {
  return (
    <ContentWrapper className={minimalFooterStyles.minimalFooterContainer}>
      <div className={minimalFooterStyles.footerLinksContainer}>
        <div className={minimalFooterStyles.footerLinks}>
          <FooterItem
            messageId="footer.terms"
            href={externalLinks.tos}
            isNewTab
          />
          <FooterItem
            textClassName={minimalFooterStyles.footerLink}
            messageId="footer.privacy_policy"
            href={externalLinks.privacy}
            isNewTab
          />
          <FooterItem
            textClassName={minimalFooterStyles.footerLink}
            messageId="footer.cookie_consent_tool"
            onClick={displayCookieConsentModal}
          />
          {!getBasename() && (
            <FooterItem
              textClassName={minimalFooterStyles.footerLink}
              messageId="footer.ad_choices"
              href={externalLinks.adChoices}
              isNewTab
            />
          )}
          {!getBasename() && (
            <FooterItem
              textClassName={minimalFooterStyles.footerLink}
              messageId="footer.privacy_choices"
              icon={FooterDoNotSellItemSvg}
              iconPosition="end"
              iconClassName={footerMoreStuffSectionStyles.doNotSellIcon}
              href={externalLinks.doNotSellMyPersonalInformation}
              isNewTab
            />
          )}
        </div>
      </div>
      <div>
        <FooterCopyrightSection />
      </div>
    </ContentWrapper>
  );
};

export default MinimalFooter;
